// eslint-disable-next-line import/no-anonymous-default-export
export default {
  EMAIL_NOT_FOUND: "Your email address is not found",
  INVALID_PASSWORD: "Your password is invalid",
  "WEAK_PASSWORD : Password should be at least 6 characters":
    "Password should be at least 6 characters",
  required: "This field is required",
  positive: "This field must be greater than 1",
  undefiend: "no error",
  TOO_MANY_ATTEMPTS_TRY_LATER: "Too many Attempts, Try Later",
};
